export default "__VITE_ASSET__DtxeYBEX__"